<template>
  <div class="support">
    <h1 class="support-title">Отправить запрос</h1>
    <form
      @submit.prevent="sendRequest"
      enctype="multipart/form-data"
      method="post"
      class="support-request__form"
      autocomplete="off"
    >
      <div class="support-request__form-mail">
        <label class="support-request__form-mail__label" for="requester__mail"
          >Адрес эл. почты</label
        >
        <InputText
          v-if="this.selectedReason == 'Корректировка данных в заказе'"
          type="text"
          v-model="requesterMail"
          id="requester__mail"
          class="support-request__form-mail__input"
        />
        <InputText
          v-else-if="this.mail"
          type="text"
          v-model="requesterMail"
          id="requester__mail"
          class="support-request__form-mail__input"
          disabled
        />
        <InputText
          required
          v-else
          type="text"
          v-model="requesterMail"
          id="requester__mail"
          class="support-request__form-mail__input"
        />
      </div>
      <div class="support-request__form-ordernum">
        <label
          class="support-request__form-ordernum__title"
          for="request__ordernum"
          >Номер заказа</label
        >
        <InputText
          v-if="this.orderId"
          type="text"
          v-model="requestOrderNum"
          id="request__ordernum"
          class="support-request__form-ordernum__input"
          disabled
        />
        <InputText
          required
          v-else
          type="text"
          v-model="requestOrderNum"
          id="request__ordernum"
          class="support-request__form-ordernum__input"
        />
      </div>
      <div class="support-request__form-reason">
        <h3 class="support-request__form-reason__title">Причина обращения</h3>
        <InputText
          v-if="this.reason"
          class="support-request__form-reason__select"
          v-model="selectedReason"
          disabled
        />

        <Dropdown
          v-else
          class="support-request__form-reason__select"
          v-model="selectedReason"
          :options="reasons"
          optionLabel="name"
          placeholder="Выберите причину"
        />
        <p class="support-request__form-upload__alert" v-show="this.reasonError">
          Необходимо выбрать причину обращения!
        </p>
        <div class="support-request__form-reason__description">
          <div
            v-if="
              this.selectedReason == 'Заказ специальных услуг' ||
              this.selectedReason.name == 'Заказ специальных услуг'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              Запрос на специальные услуги перевозчика (провоз спортивного
              оборудования, заказ люльки для младенца до 1 года, провоз
              инвалидного кресла, сопровождение пассажира с ограниченными
              возможностями и т.д.). Рекомендуется отправлять запрос более чем
              за 48 часов до вылета.
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Обмен билета' ||
              this.selectedReason.name == 'Обмен билета'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              Вы можете изменить в рамках одной авиакомпании рейс, дату вылета,
              класс обслуживания.<br />
              <br />
              В обращении укажите желаемые изменения по вашему билету. Мы
              выполним проверку возможности обмена и направим вам расчет
              стоимости или предложим другой вариант обмена, если указанный вами
              не возможен.
              <br />
              <br />
              Оплата по ссылке, размещенной в ответном письме, подтверждает ваше
              согласие со всеми условиями обмена. После получения оплаты
              отправим вам новые электронные авиабилеты. <br />
              <br />
              Если желаете изменить маршрут, авиакомпанию или данные пассажира
              (ФИО, дата рождения, паспортные данные), вам необходимо
              осуществить возврат и купить новый авиабилет.
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Оформление билета на ребёнка' ||
              this.selectedReason.name == 'Оформление билета на ребёнка'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              Для оформления отдельного билета на ребенка (в том числе, без
              предоставления места) прикрепите к запросу билет взрослого
              пассажира и скан-копию документа, удостоверяющего личность ребёнка
              (свидетельство о рождении или заграничный паспорт).
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Корректировка данных в заказе' ||
              this.selectedReason.name == 'Корректировка данных в заказе'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              В обращении укажите верные данные, которые нужно внести в
              заказ.<br />
              <br />
              Мы проверим возможность внесения изменений и предоставим вам
              расчет стоимости. Оплата по ссылке, размещенной в ответном письме,
              подтверждает ваше согласие на корректировку заказа.<br />
              <br />
              После получения оплаты отправим вам новые новые электронные
              авиабилеты с внесенными изменениями.
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Изменение расписания' ||
              this.selectedReason.name == 'Изменение расписания'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              Выберите эту причину обращения, если вы получили сообщение о
              существенном изменении времени вылета, замене или отмене рейса,
              после чего вам требуется переоформление билета на вариант,
              предложенный в оповещении, или подбор альтернативного рейса. Если
              после изменения расписания авиакомпании вы решили отказаться от
              билета, выберите причину обращения «возврат» и тип возврата
              «вынужденный».
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Не пришёл билет' ||
              this.selectedReason.name == 'Не пришёл билет'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              В обращении укажите номер заказа, который вы оплатили, но не
              получили билеты. Приложите подтверждение оплаты заказа. Если не
              помните номер заказа, напишите фамилию пассажира, маршрут, номер
              телефона, который указали в заказе.
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Запрос на перевозку животного' ||
              this.selectedReason.name == 'Запрос на перевозку животного'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              Услуга по созданию запроса на перевозку животного платная,
              стоимость 200 руб.<br />
              <br />
              В обращении укажите информацию о животном. Мы проверим возможность
              перевозки животного и отправим вам ссылку на оплату услуги.<br />
              <br />
              Оплата по ссылке, размещенной в ответном письме, подтверждает ваше
              согласие с условиями оказания услуги.
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Дополнительный багаж' ||
              this.selectedReason.name == 'Дополнительный багаж'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              В обращении укажите информацию о дополнительном багаже. Мы
              проверим возможность оформления дополнительного багажа и отправим
              вам расчет стоимости.<br />
              <br />
              Оплата по ссылке, размещенной в ответном письме, подтверждает ваше
              согласие со всеми условиями оформления дополнительного багажа.<br />
              <br />
              После оплаты оформим багаж и отправим вам багажную квитанцию.
            </p>
          </div>
          <div
            v-else-if="
              this.selectedReason == 'Другое' ||
              this.selectedReason.name == 'Другое'
            "
            class="support-request__form-reason__description-item"
          >
            <p class="support-request__form-reason__description-item__text">
              Используйте данный вид обращения, если ни одна из причин указанных
              в списке выбора вам не подошла. Опишите суть вашего обращения и
              приложите необходимые документы, которые помогут нам его решить.
              Это может быть скриншет экрана, подтверждение банка о совершенном
              платеже, переписка с авиакомпанией или скан документа пассажира.
            </p>
          </div>
        </div>
      </div>
      <div class="support-request__form-subject">
        <label
          class="support-request__form-subject__label"
          for="request__subject"
          >Тема <span class="request__optional">(необязательно)</span></label
        >
        <InputText
          type="text"
          v-model.lazy="requestSubject"
          id="request__subject"
          class="support-request__form-subject__input"
          autocomplete="off"
        />
      </div>
      <div
        v-if="
          this.showTicket ||
          this.showBaggage ||
          this.showPayment ||
          this.showRefund
        "
        class="support-request__form-suggestion"
      >
        <Accordion v-model:activeIndex="activeIndex" aria-expanded="true">
          <AccordionTab header="Рекомендуемые статьи">
            <div
              class="support-request__form-suggestion__wrapper"
              v-if="this.showTicket"
            >
              <ul class="support-request__form-suggestion__list">
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/customer/Pages/BookingAirticketsHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как купить авиабилет онлайн?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/SvidetelsvoRojdeniiHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как правильно вносить данные свидетельства о рождении и в
                    каких случаях его нужно вводить?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/FareBrandHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Чем отличаются тарифы между собой?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/ETicketHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Что такое электронный билет?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/AirTicketRestrictionsHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Какие есть ограничения при покупке билета?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/AloneChildHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как купить билет ребенку, которые путешествует без
                    сопровождения взрослого пассажира?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/OwnErrorsInOrderHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >При оформлении билета я допустил ошибку, что мне делать?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/NoConfirmationEmailHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Что делать, если я не получу письмо, подтверждающее
                    приобретение авиабилета?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/ErrorsInConfirmationEmailHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Я обнаружил ошибку в письме-подтверждении, как быть?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href=""
                    class="support-request__form-suggestion__list-item__link"
                    >Что такое "Автоинформирование"?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/AutoinformHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Задержали рейс, что делать?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/AirTicketsMealHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Что такое спецпитание и как его заказать?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/DocUzbekistanHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Правила внесния паспортных данных гражданами
                    Узбекистана!</a
                  >
                </li>
              </ul>
            </div>
            <div
              class="support-request__form-suggestion__wrapper"
              v-else-if="this.showBaggage"
            >
              <ul class="support-request__form-suggestion__list">
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/BaggageForbidden"
                    class="support-request__form-suggestion__list-item__link"
                    >Что нельзя сдавать в багаж?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/ChargeableBaggage"
                    class="support-request__form-suggestion__list-item__link"
                    >В каких случаях нужно оплачивать багаж?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/HandLuggageAllowance"
                    class="support-request__form-suggestion__list-item__link"
                    >Сколько килограмм разрешено провозить в ручной клади?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/FreeBaggageAllowance"
                    class="support-request__form-suggestion__list-item__link"
                    >Как узнать, входит ли багаж в стоимость билета или надо
                    оплачивать его отдельно?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/BagageSafeTips"
                    class="support-request__form-suggestion__list-item__link"
                    >Можно ли как-то обезопасить свой багаж, чтобы он не
                    пропал?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/BaggageInsurance"
                    class="support-request__form-suggestion__list-item__link"
                    >Почему стоит приобретать услугу «Страхование багажа»?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/AnimalInBaggage"
                    class="support-request__form-suggestion__list-item__link"
                    >Перевозка животных</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/PlantsInBaggage"
                    class="support-request__form-suggestion__list-item__link"
                    >Перевозка растений</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/BaggageLost"
                    class="support-request__form-suggestion__list-item__link"
                    >Куда теряется багаж?</a
                  >
                </li>
              </ul>
            </div>
            <div
              class="support-request__form-suggestion__wrapper"
              v-else-if="this.showPayment"
            >
              <ul class="support-request__form-suggestion__list">
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/PaymentMethodsHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как я могу оплатить билет?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/MaxDurationOfPaymenRefundToCardHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Какой максимальный срок возврата средств при оплате
                    платежной картой?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/MirAcceptActivating"
                    class="support-request__form-suggestion__list-item__link"
                    >Что делать, если не проходит оплата по карте МИР?</a
                  >
                </li>
              </ul>
            </div>
            <div
              class="support-request__form-suggestion__wrapper"
              v-else-if="this.showRefund"
            >
              <ul class="support-request__form-suggestion__list">
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/TicketExchangeHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как измененить рейс, дату и время вылета или класс
                    обслуживания в авиабилете?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/TicketRefundInNoShowHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Я опоздал на рейс, могу ли я вернуть билет?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/TichetRefundVisaHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как вернуть авиабилет при отказе в визе?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/TicketRefundHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как выполнить возврат авиабилета?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/InsuranceRefundHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Как оформить возврат страхового полиса?</a
                  >
                </li>
                <li class="support-request__form-suggestion__list-item">
                  <a target="_blank"
                    href="https://www.biletdv.ru/Pages/AddonsRefundHelp"
                    class="support-request__form-suggestion__list-item__link"
                    >Можно ли отказаться от дополнительных услуг после покупки
                    билета?</a
                  >
                </li>
              </ul>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
      <div
        v-if="
          this.selectedReason == 'Корректировка данных в заказе' ||
          this.selectedReason.name == 'Корректировка данных в заказе'
        "
        class="support-request__form-adjustment"
      >
        <p>Внесите необходимые изменения в реквизиты заказа</p>

        <div class="support-request__form-adjustment__item">
          <span class="p-float-label">
            <InputText id="adjfullName" type="text" v-model="adjFullName" />
            <label for="adjfullName">Фамилия Имя Отчество</label>
          </span>
        </div>
        <div class="support-request__form-adjustment__item">
          <span class="p-float-label">
            <InputText id="adjbirthdate" type="text" v-model="adjBirthDate" />
            <label for="adjbirthdate">Дата рождения</label>
          </span>
        </div>
        <div class="support-request__form-adjustment__item">
          <span class="p-float-label">
            <InputText id="adjdocument" type="text" v-model="adjDocument" />
            <label for="adjdocument">Номер документа</label>
          </span>
        </div>
        <div class="support-request__form-adjustment__item">
          <span class="p-float-label">
            <InputText
              id="adjdocumentdate"
              type="text"
              v-model="adjDocumentDate"
            />
            <label for="adjdocumentdate">Срок действия документа</label>
          </span>
        </div>
        <div class="support-request__form-adjustment__item">
          <span class="p-float-label">
            <InputText id="adjphone" type="text" v-model="adjPhone" />
            <label for="adjphone">Контактный телефон</label>
          </span>
        </div>
        <div class="support-request__form-adjustment__item">
          <span class="p-float-label">
            <InputText id="adjmail" type="text" v-model="adjMail" />
            <label for="adjmail">E-mail</label>
          </span>
        </div>

        <p
          v-show="this.adjError"
          class="support-request__form-adjustment__error"
        >
          Необходимо заполнить хотя бы одно поле
        </p>
      </div>
      <div v-if="this.isLoading" class="support-request__form-description">
        <Skeleton class="order-cards__skeleton" width="120px" height="20px" />
        <Skeleton class="order-cards__skeleton" width="100%" height="240px" />
      </div>
      <div
        v-else-if="
          this.selectedReason != 'Корректировка данных в заказе' &&
          this.selectedReason.name != 'Корректировка данных в заказе' &&
          !this.isLoading
        "
        class="support-request__form-description"
      >
        <h3 class="support-request__form-description__title">Обращение</h3>
        <Editor
          class="support-request__form-description__textarea"
          v-model="description"
          editorStyle="height: 240px"
        >
          <template #toolbar>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-list" value="ordered"></button>
            </span>
          </template>
        </Editor>
      </div>
      <div class="support-request__form-upload">
        <p class="support-request__form-upload__title">
          Прикреплённые файлы
          <span
            v-if="
              this.selectedReason !== 'Оформление билета на ребёнка' &&
              this.selectedReason.name !== 'Оформление билета на ребёнка'
            "
            class="request__optional"
            >(необязательно)</span
          >
        </p>
        <p class="support-request__form-upload__alert" v-show="this.fileSizeEx">
          Размер файлов не должен привышать 20Мб, размер одного файла - не более
          10Мб.
        </p>
        <p
          class="support-request__form-upload__alert"
          v-show="this.maxFileCount"
        >
          Количество файлов - не более 10ти.
        </p>
        <p
          class="support-request__form-upload__alert"
          v-show="this.kidTicketAttach"
        >
          Необходимо прикрепить указанные в описании файлы
        </p>
        <p
          class="support-request__form-upload__alert"
          v-show="this.wrongFileFormat"
        >
          Допустимые форматы файлов: .png, .jpg, .jpeg, .pdf, .tif, .tiff,
          .pjpeg, .pjp
        </p>
        <input
          type="file"
          id="files"
          ref="files"
          multiple
          accept=".png, .jpg, .jpeg, .pdf, .tiff, .pjpeg, .pjp"
          @change="handleFileUpload()"
          class="support-request__form-upload__mob-input"
        />
        <label for="files" class="support-request__form-upload__mob"
          >Выбрать файлы</label
        >
        <div v-if="this.showAttachedFiles">
          <div
            v-for="(file, index) in this.files"
            :key="index"
            class="support-request__form-upload__show"
          >
            <p class="support-request__form-upload__show-item">
              {{ file.name }}
            </p>
          </div>
        </div>
      </div>

      <Button
        v-if="!this.isLoading"
        type="submit"
        label="Отправить"
        class="support-request__form-submit"
        :class="{ disabled: !this.checkBeforeSumbit }"
        :loading="this.isSubmiting"
      />
    </form>
    <Dialog v-model:visible="display">
      <template #header>
        <Skeleton
          v-if="this.isTicketsLoading"
          class="order-cards__skeleton"
          width="100%"
          height="20px"
        />
        <h3 v-else>Выберите билеты для обмена</h3>
      </template>
      <div
        v-if="this.isTicketsLoading"
        class="support-request__changetickets-choose__form"
      >
        <Skeleton class="order-cards__skeleton" width="140px" height="20px" />
      </div>
      <div
        v-else
        v-for="(ticket, index) in this.order.order.Passengers"
        :key="index"
        class="support-request__changetickets-choose__form"
      >
        <Checkbox
          class="support-request__changetickets-choose__form-checkbox"
          :id="'ticket' + index"
          name="tickets"
          :value="ticket.Tickets[0].Number + ' ' + '('+ ticket.LastName + ' ' + ticket.FirstName + ' ' + ticket.MiddleName + ')'"
          v-model="checkedTickets"
        />
        <label
          class="support-request__changetickets-choose__form-label"
          :for="'ticket' + index"
          >{{
            ticket.Tickets[0].Number +
            " " +
            "(" +
            this.order.order.Passengers[index].LastName +
            " " +
            (this.order.order.Passengers[index].FirstName
              ? this.order.order.Passengers[index].FirstName[0] + "."
              : "") +
            (this.order.order.Passengers[index].MiddleName
              ? this.order.order.Passengers[index].MiddleName[0] + "."
              : "") +
            ")"
          }}</label
        >
      </div>

      <p
        class="support-request__changetickets-choose__form-error"
        v-show="this.checkTicketsError"
      >
        Необходимо выбрать хотя бы один билет
      </p>

      <template #footer>
        <Skeleton
          v-if="this.isTicketsLoading"
          class="order-cards__skeleton"
          width="100%"
          height="20px"
        />
        <Button
          v-else
          label="Оформить обмен"
          autofocus
          @click="tikectsForChange"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { defineComponent, watch } from "@vue/runtime-core";
import Editor from "primevue/editor";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import axios from "axios";
import { ref } from "vue";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "Support",
  components: {
    Editor,
    Dropdown,
    InputText,
    Accordion,
    AccordionTab,
    Dialog,
    Checkbox,
    Button,
    Skeleton,
  },
  props: ["guid"],
  setup(props) {
    const isLoading = ref(false);
    const isSubmiting = ref(false);
    const isTicketsLoading = ref(false);
    const error = ref(null);
    const checkTicketsError = ref(false);
    const order = ref(null);
    const checkedTickets = ref([]);
    const display = ref(false);
    const adjError = ref(false);
    const activeIndex = ref(0);
    const reqDocNum = ref("");
    const reqDocDate = ref("");
    const reqBirthDate = ref("");
    const reqRoute = ref("");
    const reqFullName = ref("");
    const reqPhone = ref("");
    const reqTicketMail = ref("");
    const description = ref("");
    const kidTicketAttach = ref(false);
    const router = useRouter();
    const route = useRoute();
    const selectedReason = ref("");
    const reasonError = ref(false);
    const reasons = ref([
      { name: "Обмен билета" },
      { name: "Корректировка данных в заказе" },
      { name: "Оформление билета на ребёнка" },
      { name: "Запрос на перевозку животного" },
      { name: "Дополнительный багаж" },
      { name: "Не пришёл билет" },
      { name: "Другое" },
    ]);
    const adjFullName = ref("");
    const adjBirthDate = ref("");
    const adjDocument = ref("");
    const adjDocumentDate = ref("");
    const adjPhone = ref("");
    const adjMail = ref("");
    const getOrder = async () => {
      isTicketsLoading.value = true;
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetUserOrder?guid=${props.guid}&priceData=none&documentsData=none`
        );
        let fetchedPass = await json.data;
        order.value = fetchedPass;
        isTicketsLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    watch(
      [
        selectedReason,
        adjFullName,
        adjBirthDate,
        adjDocument,
        adjDocumentDate,
        adjPhone,
        adjMail,
        checkedTickets,
      ],
      (newValue, oldValue) => {
        
        const reason = selectedReason.value;
        if(reasonError.value == true && reason.name) {
          reasonError.value = false
        }
        if (reason.name == "Обмен билета") {
          description.value = `
            Добрый день. <br>
            Прошу выполнить обмен авиабилета ${
              props.orderNum ? props.orderNum : "№______"
            } <br>
            <br>
            Желаемый маршрут после обмена: <br>
            Дата Время / Номер рейса / Направление <br>
            Пример: <br>
            20.11.2020 10:00 / SU-1010 / Хабаровск-Москва <br>
            <br>`;
        } else if (reason.name == "Не пришёл билет") {
          description.value = `
            Добрый день. <br>
            Прошу прислать маршрут квитанции по заказу №______, т.к. до настоящего времени я их не получил.  <br>
            <br>
            Заказ был оформлен для пассажира: Иванов Иван Иванович. <br>
            Контактные данные, которые были указаны в заказе:  <br>
            Телефон +79010010101, E-mail: yourmail@mail.ru <br>
            Информацию о произведенном платеже прилагаю. <br>
            <br>`;
        } else if (reason.name == "Оформление билета на ребёнка") {
          description.value = `
            Добрый день. <br>
            Прошу оформить билет для ребенка, следующего в сопровождении пассажира с номером авиабилета 111-1234123456 <br>
            <br>
            Прилагаю скан копию документа удостоверяющего личность ребенка и маршрут квитанцию электронного авиабилета пассажира,<br> который его сопровождает. <br>
            <br>`;
        } else if (reason.name == "Запрос на перевозку животного") {
          description.value = `
            Добрый день. <br>
            Прошу оформить перевозку животного, следующего вместе с пассажиром по оформленному авиабилету 111-1234123456 <br>
            <br>
            Информация о животном.<br>
            <br>
            Вид животного: <br>
            Порода (только для собак): <br>
            Вес животного вместе с клеткой: <br>
            Габариты клетки (длина*ширина*высота): <br>`;
        } else if (reason.name == "Дополнительный багаж") {
          description.value = `
            Добрый день. <br>
            <br>
            Прошу оформить дополнительный багаж. <br>
            <br>
            Количество мест дополнительного багажа: <br>
            Вес каждого места багажа: <br>
            Габариты каждого места (длина*ширина*высота): <br>
            <br>`;
        } else if (reason.name == "Другое") {
          description.value = `
            Добрый день. <br>
            <br>
            С уважением, <br>
            Фамилия Имя Отчество`;
        } else if (checkedTickets.value) {
          checkTicketsError.value = false;
        } else if (
          adjFullName.value ||
          adjBirthDate.value ||
          adjDocument.value ||
          adjDocumentDate.value ||
          adjPhone.value ||
          adjMail.value
        ) {
          adjError.value = false;
        }
      }
    );
    return {
      order,
      isLoading,
      isSubmiting,
      error,
      checkedTickets,
      description,
      selectedReason,
      reasons,
      reqFullName,
      reqPhone,
      reqTicketMail,
      reqRoute,
      reqBirthDate,
      reqDocDate,
      reqDocNum,
      activeIndex,
      adjFullName,
      adjBirthDate,
      adjDocument,
      adjDocumentDate,
      adjPhone,
      adjMail,
      adjError,
      display,
      getOrder,
      isTicketsLoading,
      checkTicketsError,
      kidTicketAttach,
      reasonError
    };
  },
  data() {
    return {
      wrongFileFormat: false,
      maxFileCount: false,
      fileSizeEx: false,
      checkBeforeSumbit: true,
      showAttachedFiles: false,
      files: "",
      messages: [],
      requesterMail: this.getRequesterMail(),
      requestSubject: "",
      orderNumber: "",
      requestOrderNum: "",
      requestInsurNum: "",
    };
  },
  computed: {
    showTicket() {
      if (this.requestSubject.toLowerCase().includes("билет")) {
        return true;
      } else {
        return false;
      }
    },
    showBaggage() {
      if (this.requestSubject.toLowerCase().includes("багаж")) {
        return true;
      } else {
        return false;
      }
    },
    showPayment() {
      if (this.requestSubject.toLowerCase().includes("оплат")) {
        return true;
      } else {
        return false;
      }
    },
    showRefund() {
      if (
        this.requestSubject.toLowerCase().includes("возврат") ||
        this.requestSubject.toLowerCase().includes("вернуть") ||
        this.requestSubject.toLowerCase().includes("отказ")
      ) {
        return true;
      } else {
        return false;
      }
    },
    orderId() {
      return this.$route.params.orderId;
    },
    mail() {
      return this.$route.params.mail;
    },
    reason() {
      return this.$route.params.reason;
    },
    insur() {
      return this.$route.params.insur;
    },
    orderNum() {
      return this.$route.params.orderNum;
    },
    ticketMail() {
      return this.$route.params.ticketMail;
    },
    fullName() {
      return (
        this.$route.params.lastName +
        " " +
        this.$route.params.firstName +
        " " +
        this.$route.params.middleName
      );
    },
    phone() {
      return this.$route.params.phone;
    },
    route() {
      return this.$route.params.route;
    },
    birthDate() {
      return this.$route.params.birthDate;
    },
    docNum() {
      return this.$route.params.docNum;
    },
    docDate() {
      return this.$route.params.docDate;
    },
  },
  methods: {
    tikectsForChange() {
      if (this.checkedTickets.length == 0) {
        this.checkTicketsError = true;
      } else {
        this.isLoading = false;
        this.display = false;
        console.log(this.checkedTickets + "!!!!!!");
        let routeData = "";
        let route = this.order.order.Flights;
        for (let i = 0; i < route.length; i++) {
          console.log(route[i]);
          // let fullNameForChange = 
          let date = route[i].DepartureDate;
          let flightNum =
            route[i].OperatingAirline.CodeLat + "-" + route[i].FlightNumber;
          let routeCitys =
            route[i].Departure.City.NameRus +
            "-" +
            route[i].Arrival.City.NameRus;
          let routeString =
            this.getDotDate(date) +
            " " +
            this.getTime(date) +
            " / " +
            flightNum +
            " / " +
            routeCitys +
            "<br>";
          routeData += routeString;
        }
        let ticketsForDesc = "";
        for (let i = 0; i < this.checkedTickets.length; i++) {
          ticketsForDesc += this.checkedTickets[i];
          if (i < this.checkedTickets.length - 1) {
            ticketsForDesc += "," + " ";
          }
        }
        this.description = `
            Добрый день. <br>
            ${
              this.checkedTickets.length > 1
                ? "Прошу выполнить обмен авиабилетов " + ticketsForDesc + "<br>"
                : "Прошу выполнить обмен авиабилета " + ticketsForDesc + "<br>"
            }
            
            <br>
            Желаемый маршрут после обмена: <br>
            ${routeData}
            <br>`;
      }
    },
    getRequesterMail() {
      let mailInfo = sessionStorage.getItem("userName");
      let mail;
      if (mailInfo) {
        mail = JSON.parse(mailInfo);
        return mail;
      } else {
        return "";
      }
    },
    getDotDate(date) {
      let dotDate;
      let fullDate = new Date(date);
      let day = fullDate.getDate();
      let month = fullDate.getMonth();
      let fullMonth;
      let year = fullDate.getFullYear();
      if (month + 1 < 10) {
        fullMonth = "0" + (month + 1);
      } else {
        fullMonth = month + 1;
      }
      dotDate = day + "." + fullMonth + "." + year;
      return dotDate;
    },
    getTime(date) {
      let time = new Date(date);
      let hours = time.getHours();
      let minutes = time.getMinutes();
      if (minutes < 10) {
        return hours + ":0" + minutes;
      }
      return hours + ":" + minutes;
    },
    checkFullName() {
      if (this.fullName) {
        this.reqFullName = this.fullName;
      } else {
        return;
      }
    },
    checkPhone() {
      if (this.phone) {
        this.reqPhone = this.phone;
      } else {
        return;
      }
    },
    checkOrderId() {
      if (this.orderId) {
        this.requestOrderNum = this.orderId;
      } else {
        return;
      }
    },
    checkInsurId() {
      if (this.orderId) {
        this.requestInsurNum = this.insur;
      } else {
        return;
      }
    },
    checkMail() {
      if (this.mail) {
        this.requesterMail = this.mail;
      } else {
        return;
      }
    },
    checkOrderNum() {
      if (this.orderNum) {
        this.orderNumber = this.orderNum;
      } else {
        return;
      }
    },
    checkRoute() {
      if (this.route) {
        this.reqRoute = this.route;
      } else {
        return;
      }
    },
    checkBirthDate() {
      if (this.birthDate) {
        this.reqBirthDate = this.birthDate;
      } else {
        return;
      }
    },
    checkDocNum() {
      if (this.docNum) {
        this.reqDocNum = this.docNum;
      } else {
        return;
      }
    },
    checkDocDate() {
      if (this.docDate) {
        if (this.docDate == "1.00.1") {
          return;
        } else {
          this.reqDocDate = ", срок действия: " + this.docDate;
        }
      } else {
        return;
      }
    },
    checkReason() {
      if (this.reason == "change") {
        this.selectedReason = "Обмен билета";
        this.isLoading = true;
        this.display = true;
        this.getOrder();
      } else if (this.reason == "notdeliv") {
        this.selectedReason = "Не пришёл билет";
        this.description = `
            Добрый день. <br>
            Прошу прислать маршрут квитанции по заказу ${this.requestOrderNum}, т.к. до настоящего времени я их не получил.  <br>
            <br>
            Заказ был оформлен для пассажира: ${this.reqFullName} <br>
            Контактные данные, которые были указаны в заказе:  <br>
            Телефон: ${this.reqPhone}, E-mail: ${this.requesterMail} <br>
            Информацию о произведенном платеже прилагаю. <br>
            <br>`;
      } else if (this.reason == "kid") {
        this.selectedReason = "Оформление билета на ребёнка";
        this.description = `
            Добрый день. <br>
            Прошу оформить билет для ребенка, следующего в сопровождении пассажира с номером авиабилета ${this.orderNumber} (${this.reqFullName})<br>
            <br>
            Прилагаю скан копию документа удостоверяющего личность ребенка и маршрут квитанцию электронного авиабилета пассажира, который его сопровождает. <br>
            <br>`;
      } else if (this.reason == "baggage") {
        this.selectedReason = "Дополнительный багаж";
        this.description = `
            Добрый день. <br>
            Прошу оформить дополнительный багаж. <br>
            <br>
            Количество мест дополнительного багажа: <br>
            <br>
            Вес каждого места багажа: <br>
            <br>
            Габариты каждого места (длина*ширина*высота) :  <br>
            <br>`;
      } else if (this.reason == "creature") {
        this.selectedReason = "Запрос на перевозку животного";
        this.description = `
            Добрый день. <br>
            Прошу оформить перевозку животного, следующего вместе с пассажиром по оформленному авиабилету ${this.orderNumber} (${this.reqFullName}) <br>
            <br>
            Информация о животном. <br>
            <br>
            Вид животного:  <br>
            Порода (только для собак): <br>
            Вес животного вместе с клеткой: <br>
            Габариты клетки (длина*ширина*высота):  <br>`;
      } else if (this.reason == "adjustment") {
        this.selectedReason = "Корректировка данных в заказе";
      }
    },
    handleFileUpload() {
      this.files = this.$refs.files.files;
      let filesSize = 0;
      if (this.files.length > 0) {
        this.showAttachedFiles = true;
      } else {
        this.showAttachedFiles = false;
      }
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].size > 10485760) {
          this.fileSizeEx = true;
        } else {
          this.fileSizeEx = false;
        }
        if (
          this.files[i].type !== "image/png" &&
          this.files[i].type !== "image/jpg" &&
          this.files[i].type !== "image/jpeg" &&
          this.files[i].type !== "image/pjp" &&
          this.files[i].type !== "image/pjpeg" &&
          this.files[i].type != "application/pdf" &&
          this.files[i].type !== "image/tiff"
        ) {
          console.log("must be true" + this.files[i].type);
          this.wrongFileFormat = true;
        } else {
          console.log("must be false" + this.files[i].type);
          this.wrongFileFormat = false;
        }

        filesSize += this.files[i].size;
      }
      if (filesSize > 22020096) {
        this.fileSizeEx = true;
      } else {
        this.fileSizeEx = false;
      }
      if (this.files.length > 10) {
        this.maxFileCount = true;
      } else {
        this.maxFileCount = false;
      }
      if (this.files.length == 0) {
        this.wrongFileFormat = false;
      }
      if (this.maxFileCount || this.fileSizeEx || this.wrongFileFormat) {
        this.checkBeforeSumbit = false;
      } else {
        this.checkBeforeSumbit = true;
      }
      let reason = "";
      if (this.selectedReason.name) {
        reason = this.selectedReason.name;
      } else {
        reason = this.selectedReason;
      }
      if (reason == "Оформление билета на ребёнка" && this.files.length > 0) {
        this.kidTicketAttach = false;
      }
    },
    sendRequest() {
      let reason = "";
      if (this.selectedReason.name) {
        reason = this.selectedReason.name;
      } else {
        reason = this.selectedReason;
      }
      if (reason == "Корректировка данных в заказе") {
        this.description = `
            Добрый день. <br>
            Прошу исправить данные пассажира в билете ${
              this.orderNum ? this.orderNum : "№______"
            } <br>
            <br>
            <b>Верные данные</b>: <br>
            Контактный телефон: ${this.adjPhone} <br>
            e-mail: ${this.adjMail} <br>
            Фамилия Имя Отчество: ${this.adjFullName} <br>
            Дата рождения: ${this.adjBirthDate} <br>
            Номер документа: ${this.adjDocument}<br>
            Срок действия: ${this.adjDocumentDate} <br>
            <br>`;
        if (
          !this.adjPhone &&
          !this.adjMail &&
          !this.adjFullName &&
          !this.adjBirthDate &&
          !this.adjDocument &&
          !this.adjDocumentDate
        ) {
          this.adjError = true;
        }
      }
      if(!reason) {
        this.reasonError = true
      }
      if (reason == "Оформление билета на ребёнка" && this.files.length == 0) {
        this.kidTicketAttach = true;
      } else {
        this.kidTicketAttach = false;
      }
      let bodyFormData = new FormData();
      let formData = {
        Reason: reason,
        Description: this.description,
        OrderNumber: this.requestOrderNum,
        MailAdress: this.requesterMail,
        Subject: this.requestSubject,
        TicketNumber: reason == "Обмен билета" ? "" : this.orderNumber,
        Guid: this.guid,
      };
      let json = JSON.stringify(formData);
      const blob = new Blob([json], { type: "application/json" });
      bodyFormData.append("Details", blob);

      if (this.files) {
        this.files.forEach((el) => {
          bodyFormData.append(el.name, el, el.name);
        });
      }
      if (
        this.maxFileCount ||
        this.fileSizeEx ||
        this.wrongFileFormat ||
        this.adjError == true ||
        this.kidTicketAttach ||
        this.reasonError
      ) {
        return;
      } else {
        this.isSubmiting = true;
        axios({
          method: "POST",
          url: "https://www.biletdv.ru/customer/IBEServices/SendRequestToSupport",
          data: bodyFormData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        })
          .then((res) => {
            if (res.status == 200) {
              this.$router.replace({
                name: "Success",
                params: { requestNumber: res.data.stringRequestNum },
              });
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              store.dispatch("auth/logout");
              this.$router.push("/login");
            }
          });
      }
    },
  },
  created() {
    this.checkDocDate();
    this.checkDocNum();
    this.checkBirthDate();
    this.checkRoute();
    this.checkFullName();
    this.checkPhone();
    this.checkOrderId();
    this.checkMail();
    this.checkInsurId();
    this.checkOrderNum();
    this.checkReason();
  },
});
</script>

<style lang="scss">
.support-request__form-upload__show {
  margin-top: 5px;
}
.support-request__form-upload__show-item {
  margin-top: 5px;
}
.support-request__form-upload__alert {
  font-size: 14px;
  color: red;
  margin-top: 5px;
}

.disabled {
  background-color: gray !important;
}

.support-request__form-adjustment {
  padding: 10px 10px 10px 10px;
  width: 100%;
  background: #ffffff;
  border-radius: 5px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  margin-top: 15px;
}

.support-request__form-adjustment__item {
  margin-top: 35px;
}

.support-request__form-adjustment__error {
  margin-top: 10px;
  font-size: 12px;
  color: red;
}

.support-request__changetickets-choose__form {
  margin-top: 15px;
}

.support-request__changetickets-choose__form-label {
  margin-left: 10px !important;
}

.p-dialog .p-dialog-footer {
  text-align: left !important;
}

.p-dialog-header-icons {
  display: none !important;
}

.support-request__changetickets-choose__form-error {
  color: red;
  font-size: 12px;
  margin-top: 15px;
}
@media screen and (max-width: 1024px) {
  .support-title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    margin: 2px 0 0 20px;
  }

  .support-request__form {
    margin-top: 18px;
  }

  .support-request__form-mail__label {
    font-size: 14px;
  }

  .support-request__form-mail__input {
    margin-top: 5px !important;
  }

  .support-request__form-subject {
    margin-top: 15px;
  }

  .support-request__form-subject__label {
    font-size: 14px;
  }

  .request__optional {
    font-size: 14px;
    color: #939090;
  }

  .support-request__form-subject__input {
    margin-top: 5px !important;
  }

  .support-request__form-suggestion {
    margin-top: 15px;
  }

  .support-request__form-suggestion__list {
    list-style-type: none;
    padding: 0;
  }

  .support-request__form-suggestion__list-item {
    margin-top: 5px;
  }

  .support-request__form-suggestion__list-item__link {
    text-decoration: none;
    font-size: 14px;
    color: rgba(52, 121, 198, 1);
  }

  .support-request__form-suggestion__list-item__link:hover {
    text-decoration: underline;
  }

  .support-request__form-description {
    margin-top: 15px;
  }

  .support-request__form-description__title {
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
  }

  .support-request__form-description__textarea {
    margin-top: 5px !important;
  }

  .support-request__form-reason {
    margin-top: 15px;
  }

  .support-request__form-reason__title {
    font-size: 14px;
    font-weight: normal;
  }

  .support-request__form-reason__select {
    margin-top: 5px !important;
    width: 100%;
  }

  .support-request__form-reason__description {
    margin-top: 10px;
    margin-left: 5px;
  }

  .support-request__form-reason__description-item__text {
    font-size: 14px;
    line-height: 150%;
  }

  .support-request__form-ordernum {
    margin-top: 15px;
  }

  .support-request__form-ordernum__title {
    font-size: 14px;
  }

  .support-request__form-ordernum__input {
    margin-top: 5px !important;
  }

  .support-request__form-depdate {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
  }

  .support-request__form-depdate__title {
    font-size: 14px;
  }

  .support-request__form-depdate__input-mob {
    margin-top: 5px !important;
  }

  .support-request__form-depdate__input-desc {
    display: none;
  }

  .support-request__form-deptime {
    margin-top: 15px;
  }

  .support-request__form-deptime__title {
    font-size: 14px;
  }

  .support-request__form-deptime__input {
    margin-top: 5px !important;
  }

  .support-request__form-upload {
    margin-top: 15px;
  }

  .support-request__form-upload__title {
    font-size: 14px;
  }

  .support-request__form-upload__mob-input + label {
    margin-top: 5px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    font-size: 16px;
    padding: 6px 20px 10px 20px;
    color: white;
    background-color: #2196f3;
    display: inline-block;
    border-radius: 3px;
  }

  .support-request__form-upload__mob-input + label::before {
    font-size: 1.25em;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    content: "+";
    margin-right: 5px;
  }

  .support-request__form-upload__mob-input:focus + label,
  .support-request__form-upload__mob-input + label:focus {
    background-color: #1e81d3;
  }

  .support-request__form-upload__mob-input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .support-request__form-upload__desc {
    display: none;
  }

  .support-request__form-submit {
    margin-top: 35px !important;
  }
}

@media screen and (min-width: 1025px) {
  .support-title {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    margin: 2px 0 0 20px;
  }

  .support-request__form {
    margin-top: 18px;
  }

  .support-request__form-mail__label {
    font-size: 16px;
  }

  .support-request__form-mail__input {
    margin-top: 5px !important;
  }

  .support-request__form-subject {
    margin-top: 15px;
  }

  .support-request__form-subject__label {
    font-size: 16px;
  }

  .request__optional {
    font-size: 18px;
    color: #939090;
  }

  .support-request__form-subject__input {
    margin-top: 5px !important;
  }

  .support-request__form-suggestion {
    margin-top: 15px;
    max-width: fit-content;
  }

  .support-request__form-suggestion__list {
    list-style-type: none;
    padding: 0;
  }

  .support-request__form-suggestion__list-item {
    margin-top: 5px;
  }

  .support-request__form-suggestion__list-item__link {
    text-decoration: none;
    font-size: 16px;
    color: rgba(52, 121, 198, 1);
  }

  .support-request__form-suggestion__list-item__link:hover {
    text-decoration: underline;
  }

  .support-request__form-description {
    margin-top: 15px;
  }

  .support-request__form-description__title {
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
  }

  .support-request__form-description__textarea {
    margin-top: 5px !important;
  }

  .support-request__form-reason {
    margin-top: 15px;
  }

  .support-request__form-reason__title {
    font-size: 16px;
    font-weight: normal;
  }

  .support-request__form-reason__select {
    margin-top: 5px !important;
    width: 100%;
  }

  .support-request__form-reason__description {
    margin-top: 10px;
    margin-left: 5px;
  }

  .support-request__form-reason__description-item {
    max-width: fit-content;
  }

  .support-request__form-reason__description-item__text {
    font-size: 16px;
    line-height: 150%;
  }

  .support-request__form-ordernum {
    margin-top: 15px;
  }

  .support-request__form-ordernum__title {
    font-size: 16px;
  }

  .support-request__form-ordernum__input {
    margin-top: 5px !important;
  }

  .support-request__form-depdate {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
  }

  .support-request__form-depdate__title {
    font-size: 16px;
  }

  .support-request__form-upload__mob-input + label {
    margin-top: 5px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";

    font-size: 16px;
    padding: 6px 20px 10px 20px;
    color: white;
    background-color: #2196f3;
    display: inline-block;
    border-radius: 3px;
  }

  .support-request__form-upload__mob-input + label::before {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    font-size: 1em;
    content: "+";
    margin-right: 5px;
  }

  .support-request__form-upload__mob-input:focus + label,
  .support-request__form-upload__mob-input + label:focus {
    background-color: #1e81d3;
  }

  .support-request__form-upload__mob-input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .support-request__form-deptime {
    margin-top: 15px;
  }

  .support-request__form-deptime__title {
    font-size: 16px;
  }

  .support-request__form-deptime__input {
    margin-top: 5px !important;
  }

  .support-request__form-upload {
    margin-top: 15px;
  }

  .support-request__form-upload__title {
    font-size: 16px;
  }

  .support-request__form-upload__mob {
    display: none;
  }

  .support-request__form-upload__desc {
    margin-top: 5px !important;
  }

  .support-request__form-submit {
    margin-top: 35px !important;
  }
}
</style>
